import React from "react";
import { useNavigate } from "react-router-dom";
import { Bell, ChevronLeft } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { Avatar } from "../common/Avatar";

interface HeaderProps {
  title?: string;
  showBack?: boolean;
  showNotifications?: boolean;
  rightAction?: React.ReactNode;
}

export function Header({
  title,
  showBack = false,
  showNotifications = true,
  rightAction,
}: HeaderProps) {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <header className='sticky top-0 z-30 bg-primary-800 text-white px-4 py-3 flex items-center gap-3 md:static md:top-auto md:z-auto md:bg-white md:border-b md:border-gray-200 md:text-primary-800 md:py-3 md:px-6'>
      {showBack && (
        <button
          onClick={() => navigate(-1)}
          className='p-1 -ml-1 rounded-lg hover:bg-white/10 active:bg-white/20 md:hover:bg-gray-100 md:active:bg-gray-200 md:text-primary-800'
          aria-label='Go back'
        >
          <ChevronLeft size={24} />
        </button>
      )}

      {title ? (
        <h1 className='flex-1 text-lg font-bold truncate'>{title}</h1>
      ) : (
        <div className='flex-1 flex items-center gap-2'>
          <img
            src='/logo.png'
            alt=''
            className='h-7 w-7 rounded-lg object-contain'
          />
          <p className='text-xs text-white/70 leading-none md:hidden'>
            Welcome back
          </p>
          <p className='text-base font-bold leading-tight truncate'>
            {user?.firstName ? `Hi, ${user.firstName}` : "Golf Kraken"}
          </p>
        </div>
      )}

      {/* Desktop-visible right action (Bell/Avatar are hidden on desktop via md:hidden below) */}
      {rightAction && (
        <div className='hidden md:flex items-center gap-2 text-primary-800'>
          {rightAction}
        </div>
      )}

      <div className='flex items-center gap-2 md:hidden'>
        {rightAction}
        {showNotifications && (
          <button
            className='p-1.5 rounded-lg hover:bg-white/10 active:bg-white/20 relative'
            aria-label='Notifications'
          >
            <Bell size={20} />
          </button>
        )}
        <button onClick={() => navigate("/more")} aria-label='Profile'>
          <Avatar src={user?.photoURL} name={user?.displayName} size='sm' />
        </button>
      </div>
    </header>
  );
}
